import type { FC } from 'react'
import { memo } from 'react'

import CommonButtons from './components/commonButtons'
import DetailsButton from './components/detailsButton'
import Toolbar from './components/toolbar'

import type { DomainNode } from '@app/types'

interface Props {
  node: DomainNode
}

const EntityToolbar: FC<Props> = ({ node }) => {
  const { strategyId } = node
  const route = `/strategy/${strategyId}/map/entity/${node.data.id}`

  return (
    <Toolbar strategyId={strategyId}>
      <DetailsButton path={route} />
      <CommonButtons node={node} />
    </Toolbar>
  )
}

export default memo(EntityToolbar)
